<div class="modal-content">
    <div class="modal-header bg-black">
        <div class="modal-title">
            <h6 class="text-white">MDA Service</h6>
        </div>

        <button type="button" class="btn-close" aria-label="close" (click)="close()">
            <img src="assets/img/icon_cancel.png" alt="close icon">
        </button>
    </div>
    <div>
        <div class="modal-body my-3 px-3">
            <div>
                <form [formGroup]="form">
                    <div class="">
                        <div *ngIf="showErrorMessageTrigger" class="alert alert-danger mt-4 container">
                            <div class="d-flex mb-2">
                                <span class="iconify me-2" data-icon="clarity:warning-alt-filled"
                                    style="font-size: 24px"></span>
                                {{ getErrorMessage() }}
                            </div>
                        </div>
                        <div *ngIf="showSuccessMessageTrigger" [ngClass]="{ anim: showSuccessMessageTrigger }"
                            class="d-custom-none alert alert-success my-4 fs-14 text-center">
                            {{ getSuccessMessage() | titlecase }}
                        </div>
                        <div class="row my-2">
                            <div class="col-md-6">
                                <label class="form-label required"> MDA Name </label>
                                <select class="form-control custom-select" formControlName="mdaListId">
                                    <option [value]="mdaId" [selected]="true">{{mdaName}}</option>
                                </select>

                               

                                <app-error-message [form]="form" [controlName]="'mdaListId'"
                                    [label]="'MDA Name'"></app-error-message>
                            </div>

                            <div class="col-md-6">
                                <label class="form-label required"> Revenue Name </label>
                                <!-- <select *ngIf="mdaExtendedRevenue$ | async as mdaExtendedRevenue else loading"
                                    class="form-control custom-select" formControlName="revenueId">
                                    <option [value]="d?.id" *ngFor="let d of mdaExtendedRevenue">{{ d?.name }}
                                    </option>
                                </select> -->
                                <ng-select *ngIf="mdaExtendedRevenue$ | async as mdaExtendedRevenue else loading" [items]="mdaExtendedRevenue" bindLabel="name" [closeOnSelect]="true"
                                    bindValue="id" class="custom-select" formControlName="revenueId" placeholder="Select Revenue Name">
                                </ng-select>
                                <app-error-message [form]="form" [controlName]="'revenueId'"
                                    [label]="'Revenue Name'"></app-error-message>
                            </div>
                        </div>
                        <div class="row my-4">
                            <div class="col-md-6">
                                <label class="form-label required"> Service Type </label>
                                <select class="form-control custom-select" formControlName="serviceType">
                                    <ng-container>
                                        <option [value]="''">Select Service Type</option>
                                        <option [value]="d" *ngFor="let d of rateType">{{ d }}</option>
                                    </ng-container>
                                </select>
                                <app-error-message [form]="form" [controlName]="'serviceType'"
                                    [label]="'Service Type'"></app-error-message>
                            </div>


                        <!-- Show only when CUSTOM is selected -->
<div class="col-md-10 mt-3 mb-3" *ngIf="form.get('serviceType')?.value == 'CUSTOM'">
    <div class="p-3 border rounded bg-light">
      <div class="row g-3">
        <div class="col-md-4">
          <label class="form-label required">Custom Service Name</label>
          <input type="text" class="form-control" formControlName="customName" placeholder="Enter service name"/>
        </div>
        <div class="col-md-4">
          <label class="form-label required">Custom Type</label>
          <select class="form-control" formControlName="customType">
            <option value="">Select Type</option>
            <option value="FIXED">Fixed</option>
            <option value="REGISTRATION_AND_RENEWAL">Registration and Renewal</option>
          </select>
        </div>
  
        <div class="col-md-4">
          <label class="form-label required">Description</label>
          <textarea
            class="form-control custom-input"
            placeholder="Enter description"
            formControlName="customDescription"
            rows="3"
          ></textarea>
        </div>
  
        <div class="col-md-4" *ngIf="form.get('customType')?.value == 'FIXED'">
          <label class="form-label required"> Amount (₦)</label>
          <input type="text" class="form-control custom-input" placeholder="Enter Amount"
            formControlName="customAmount" separator />
        </div>
        <div *ngIf="form.get('customType')?.value == 'REGISTRATION_AND_RENEWAL'" class="col-md-4">
          <label class="form-label required"> Registration Amount (₦)</label>
          <input type="text" class="form-control custom-input" placeholder="Enter Amount"
            formControlName="customRegAmount" separator />
        </div>
        <div *ngIf="form.get('customType')?.value == 'REGISTRATION_AND_RENEWAL'" class="col-md-4">
          <label class="form-label required"> Renewal Amount (₦)</label>
          <input type="text" class="form-control custom-input" placeholder="Enter Amount"
            formControlName="customRenewalAmount" separator />
        </div>
  
        <div class="col-md-3 d-flex align-items-end">
          <button type="button" class="btn btn-primary w-100" (click)="addCustomService()">
            Add
          </button>
        </div>
      </div>
  
      <!-- List of added custom services -->
      <div class="mt-4 col-md-10" *ngIf="customServices.length > 0">
        <h6>Added Custom Services</h6>
        <table class="table table-bordered table-striped">
          <thead class="table-dark">
            <tr>
              <th class="assess-table-head">#</th>
              <th class="assess-table-head">Service Name</th>
              <th class="assess-table-head">Type</th>
              <th class="assess-table-head">Amount (₦)</th>
              <th class="assess-table-head">Reg. Amount(₦)</th>
              <th class="assess-table-head">Renewal Amount (₦)</th>
              <th class="assess-table-head">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let cs of customServices; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ cs.name | titlecase}}</td>
              <td>{{ cs.type | removeUnderscores | titlecase}}</td>
              <td>{{ cs.amount || 'Not Applicable' }}</td>
              <td>{{ cs.regAmount || 'Not Applicable' }}</td>
              <td>{{ cs.renewalAmount || 'Not Applicable' }}</td>
              <td>
                <button type="button" class="btn btn-sm btn-danger" (click)="removeCustomService(i)">
                  Remove
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  




                            <div class="col-md-6">
                                <label class="form-label required">Revenue Description</label>
                                <input type="text" class="form-control custom-input"
                                    placeholder="Enter revenue description" formControlName="revenueDescription" />
                                <app-error-message [form]="form" [controlName]="'revenueDescription'"
                                    [label]="'Revenue Description'"></app-error-message>
                            </div>
                        </div>

                        <div class="row my-4">
                            <div class="col-md-6">
                                <label class="form-label required"> Revenue Code </label>
                                <input type="text" class="form-control custom-input" placeholder="Enter revenue code"
                                    formControlName="revenueCode" />
                                <app-error-message [form]="form" [controlName]="'revenueCode'"
                                    [label]="'Revenue Code'"></app-error-message>
                            </div>
                            <div class="col-md-6" *ngIf="!isServiceType() && form.get('serviceType')?.value != 'CUSTOM'">
                                <label class="form-label required"> Amount (₦)</label>
                                <input type="text" class="form-control custom-input" placeholder="Enter Amount"
                                    formControlName="amount" separator />
                                <app-error-message [form]="form" [controlName]="'amount'"
                                    [label]="'amount'"></app-error-message>
                            </div>
                            <div class="col-md-6" *ngIf="isServiceType() && form.get('serviceType')?.value != 'CUSTOM'">
                                <label class="form-label required"> Percentage </label>
                                <input type="text" class="form-control custom-input" placeholder="Enter Percentage"
                                    formControlName="amount" />
                                <app-error-message [form]="form" [controlName]="'amount'"
                                    [label]="'amount'"></app-error-message>
                            </div>
                        </div>

                    </div>

                    <span class="fw-bolder text-decoration-underline ">Check boxes of the following custom field if
                        applicable.</span>
                    <div class="checkboxes mt-3">
                        <label class="checkbox"><input type="checkbox" formControlName="location"> Location</label>
                        <label class="checkbox"><input type="checkbox" formControlName="land">Land parameters</label>
                        <label class="checkbox"><input type="checkbox" formControlName="uploads"> Uploads</label>
                        <label class="checkbox"><input type="checkbox" formControlName="period"> Period</label>

                    </div>
                </form>
            </div>


            <div
            class="mt-4 p-3 col-md-10 border rounded bg-light"
            *ngIf="form.get('uploads')?.value && form.get('serviceType')?.value === 'CUSTOM'"
          >
            <h6>Add Required Upload Files</h6>
          
            <div class="row">
              <div class="col-md-6">
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="newUploadFile"
                  placeholder="Enter file name (e.g. Certificate)"
                />
              </div>
              <div class="col-md-3">
                <button type="button" class="btn btn-primary w-100" (click)="addUploadFile()">
                  Add
                </button>
              </div>
            </div>
          
            <!-- Display added files in a table -->
            <div class="mt-3 col-md-6" *ngIf="uploadFiles.length > 0">
              <table class="table table-bordered table-sm">
                <thead class="table-dark">
                  <tr>
                    <th class="assess-table-head">#</th>
                    <th class="assess-table-head">File Name</th>
                    <th class="assess-table-head">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let file of uploadFiles; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ file?.name }}</td>
                    <td>
                      <button
                        type="button"
                        class="btn btn-sm btn-danger"
                        (click)="removeUploadFile(i)"
                      >
                        Remove
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
                  </div>

         
        <div class="d-flex justify-content-center container w-100 mt-3">
            <button (click)="createMDA()" style="font-size: 14px" type="button"
                class="btn fs-14 btn-lg px-5 mb-3 rounded-0 custom-btn w-100">
                <ng-container *ngIf="submitting">
                    <span><span class="iconify icon" data-icon="eos-icons:loading"></span></span>
                </ng-container>
                Create MDA Service
            </button>
        </div>
    </div>
</div>

<ng-template #loading>
    <select class="form-control">
        <option [value]="''" disabled selected> Loading...</option>
    </select>
</ng-template>